import { Investment } from '../../models/investment';

const reducer = (prevValue, currentValue) => ({
  landCost: prevValue.landCost + +currentValue.landCost,
  propertyInvestment:
    prevValue.propertyInvestment + +currentValue.propertyInvestment,
  retailInvestment: prevValue.retailInvestment + +currentValue.retailInvestment,
  retailCost: prevValue.retailCost + +currentValue.retailCost,
});
const initialReducerValue = {
  landCost: 0,
  propertyInvestment: 0,
  retailInvestment: 0,
  retailCost: 0,
};
export const returnTotalInvestment = (investments: Investment[]) =>
  investments
    ? investments.reduce(reducer, initialReducerValue)
    : initialReducerValue;

export const calculateTotal = (investment) =>
  (
    (parseFloat(investment?.propertyInvestment || 0) ||
      parseFloat(investment?.landCost || 0)) +
    parseFloat(investment?.retailInvestment || 0) +
    parseFloat(investment?.retailCost || 0)
  ).toFixed(0);

export const getTotalInvestmentSuffixLabel = (
  currency,
  total,
  currencyRate,
) => {
  const isEuro = currency === '€';
  const totalNumber = Number(total);
  const showEuro = !isEuro && total != null && !Number.isNaN(totalNumber);
  const euroValue = showEuro ? totalNumber * currencyRate : null;
  const formattedEuro =
    euroValue !== null
      ? euroValue.toLocaleString(undefined, {
          maximumFractionDigits: 0,
        })
      : '';
  const mainSuffix = `${currency ? `K${currency}` : 'K'}`;
  const euroSuffix = showEuro ? ` | ${formattedEuro}K€` : '';
  return `${mainSuffix}${euroSuffix}`;
};
